import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FiUsers, FiFileText, FiLogOut,
  FiMapPin, FiTrendingUp
} from 'react-icons/fi';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', name: 'Dashboard', icon: FiTrendingUp },
    { path: '/admin/showrooms', name: 'Showrooms', icon: FiMapPin },
    { path: '/admin/users', name: 'Users', icon: FiUsers },
    { path: '/admin/warranties', name: 'Warranties', icon: FiFileText },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <aside
      className="w-64 flex-shrink-0 flex flex-col sticky top-16 bg-gray-50 border-r border-gray-200"
      style={{ height: 'calc(100vh - 64px)' }}
    >
      {/* User Info */}
      <div className="px-5 py-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Logged in as</p>
        <p className="text-gray-900 text-sm font-semibold break-words">
          {user.name || user.email || user.username || 'Admin'}
        </p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-3 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-5 py-3 text-sm font-medium transition-all duration-150 border-l-4 ${
                active
                  ? 'bg-white text-syakar-navy border-syakar-red'
                  : 'text-gray-800 border-transparent hover:bg-gray-700 hover:text-white'
              }`}
            >
              <Icon size={18} className="flex-shrink-0" />
              <span>{item.name}</span>
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-800 hover:text-white hover:bg-red-900 rounded-lg transition-all text-sm font-medium"
        >
          <FiLogOut size={18} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
